@if (loadingLocalEntrega) {
  <div class="text-center p-3">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
    <p class="mt-2 text-secondary">Carregando locais de entrega...</p>
  </div>
}
@if (erroLocalEntrega) {
  <div class="text-center p-3 text-danger">{{ erroLocalEntrega }}</div>
}
@if (!loadingLocalEntrega && !erroLocalEntrega && clienteLocaisEntrega.length == 0) {
  <div class="text-center p-3 text-secondary">Nenhum local de entrega cadastrado.</div>
}
@if (!loadingLocalEntrega && !erroLocalEntrega && clienteLocaisEntrega.length > 0) {
  <div class="table-responsive">
    <table class="table table-sm pedido-modal-locais-entrega-tabela">
      <thead>
        <tr>
          <th class="text-left">Local de Entrega</th>
          <th class="text-center tabela_borda">Cidade/UF</th>
          <th class="text-center tabela_borda">CEP</th>
          <th class="text-left tabela_borda">Endereço</th>
          <th class="text-center tabela_borda">Nº</th>
          <th class="text-left tabela_borda">Bairro</th>
          <th class="text-center tabela_borda">Ativo</th>
        </tr>
      </thead>
      <tbody>
        @for (local of clienteLocaisEntrega; track local) {
          <tr>
            <td class="text-left" data-label="Local de Entrega">{{ local.localentrega }}</td>
            <td class="text-center tabela_borda" data-label="Cidade/UF">{{ local.cidadeentrega }}/{{ local.ufentrega }}</td>
            <td class="text-center tabela_borda" data-label="CEP">{{ local.cepentrega }}</td>
            <td class="text-left tabela_borda" data-label="Endereço">{{ local.enderecoentrega }}</td>
            <td class="text-center tabela_borda" data-label="Nº">{{ local.nrentrega }}</td>
            <td class="text-left tabela_borda" data-label="Bairro">{{ local.bairroentrega }}</td>
            <td class="text-center tabela_borda" data-label="Ativo">{{ local.ativo ? 'Sim' : 'Não' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
